module.exports = {
  SUBMITTED: 'submitted',
  OPEN: 'open',
  VALIDATED: 'validated',
  POOL: 'pool',
  REFUSED: 'refused',
};
